module.exports = __webpack_public_path__ + "static/media/gallery3.d16ac342.png";